import { FeatureFlag } from '../types/featureFlag';

/* The list of flags the app knows about, and the pure helpers over it.
 *
 * Kept free of imports beyond the flag enum, and on relative paths, because the Storybook
 * manager bundles this file separately from the app: it resolves neither the `@/` alias nor
 * anything that expects a browser app around it.
 */

// Sorted, which is the order every picker lists them in: a row never moves out from under the
// pointer as it is ticked.
export const ALL_FEATURE_FLAGS: FeatureFlag[] = Object.values(FeatureFlag).sort();

export const isFeatureFlag = (value: string): value is FeatureFlag =>
    ALL_FEATURE_FLAGS.some((flag) => flag === value);

/* Matches a flag against what someone typed, ignoring case and treating underscores as
 * spaces, with every token having to appear somewhere. Typing "clinician team" finds
 * DASHBOARD_EDIT_CLINICIAN_TEAM_DIALOG_V2 without having to guess the exact constant.
 */
export const matchesFlagFilter = (flag: string, filter: string): boolean => {
    const haystack = flag.toLowerCase().replace(/_/g, ' ');
    return filter
        .toLowerCase()
        .split(/\s+/)
        .filter((token) => token !== '')
        .every((token) => haystack.includes(token));
};

export const toggleFlag = (flags: FeatureFlag[], flag: FeatureFlag): FeatureFlag[] =>
    flags.some((enabled) => enabled === flag)
        ? flags.filter((enabled) => enabled !== flag)
        : [...flags, flag];
